import script from "./HistoryUsersList.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryUsersList.vue?vue&type=script&setup=true&lang=js"

import "./HistoryUsersList.vue?vue&type=style&index=0&id=a0ce5f4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0ce5f4c"]])

export default __exports__